import React, { FC } from 'react';
import { Form, Slider } from '@bynder/design-system';
import { CropSettingProps } from './types';

const CropSetting: FC<CropSettingProps> = ({
    label,
    name,
    value,
    format,
    min,
    max,
    isFromCenter = true,
    setSettingValue,
    disabled,
    ...props
}) => {
    const factor = format === 'percent' ? 100 : 1;

    const onChange = (val: number) => {
        if (disabled) {
            return;
        }

        setSettingValue(Number((val / factor).toFixed(2)), name);
    };

    const sliderValue = Math.round(value * factor);
    let minValue = Math.round(sliderValue < min * factor ? sliderValue : min * factor);
    let maxValue = Math.round(sliderValue > max * factor ? sliderValue : max * factor);

    const isMinMaxEqual = minValue === maxValue;

    if (isMinMaxEqual && disabled) {
        maxValue = 200;
    } else if (isMinMaxEqual) {
        maxValue = minValue + 1;
    }

    return (
        <Form.Group>
            <Form.Label>{label}</Form.Label>
            <Slider
                value={sliderValue}
                min={minValue}
                max={maxValue}
                isFromCenter={isFromCenter}
                inputPosition="right"
                onChange={onChange}
                isInactive={disabled || isMinMaxEqual}
                isTooltipHidden={disabled || isMinMaxEqual}
                ariaLabelRightInput={label}
                isDisabled={disabled || isMinMaxEqual}
                {...props}
            />
        </Form.Group>
    );
};

export default CropSetting;
